import { ProcessResourceSelector } from '@/components/form/process-resource-selector'

export const Resource = () => {
  return <ProcessResourceSelector />
}
